export default "__VITE_ASSET__CRf8q0YM__"